import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { promoCodes } from 'src/constants/promoCodes'
import { commonCtaText } from 'src/modules/utils/constants'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    title="Stream Live TV & Sports"
    subtitle={
      <>
        Enjoy a special offer through Disco.
        <br />
        Save $25/mo off your first two months.
      </>
    }
    offerCode={promoCodes.partner_offer}
    ctaText={commonCtaText.startWatchingForFree}
    noIndex={true}
  />
)
